import http from "@/axiosConfig";
import toast from "@/global/ToastConfig";

const scheduleRoute = {
    FIND_BY_TYPE_COMPANY: "dashboard/income/schedule/findByTypeAndCompany",
};

export default {
    findByTypeAndCompany(type, companyId) {
        return new Promise(resolve => {
            let newData = [];
            http.get(scheduleRoute.FIND_BY_TYPE_COMPANY,
                {params: {type, companyId}})
                .then(({data}) => {
                    const code = data.code;
                    if (code === 0) {
                        toast.info("No se encontraron horarios configurados para la empresa");
                        return;
                    }
                    if (code <= 0) {
                        toast.error("Error al consultar los horarios");
                        return;
                    }
                    newData = data.info;
                })
                .catch(() => toast.error("Error al consultar los horarios"))
                .finally(() => resolve(newData));
        });
    }
};